export const filtersNewTrendingFeatured = [
  { value: 'new', title: 'New' },
  { value: 'trending', title: 'Trending' },
  { value: 'featured', title: 'Featured' },
]
